"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ViewReceipts=void 0;const ViewReceipts=exports.ViewReceipts="View Receipts";